'use client'

import { HomeContainer } from '@/components/common'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'
import { Marquee, MarqueeItem } from './marquee'

const galleryImages = [
  '/image/August2025/mceclip9_42.jpg',
  '/image/August2025/mceclip14_85.jpg',
  '/image/August2025/mceclip13_22.jpg',
  '/image/August2025/mceclip10_14.jpg',
  '/image/August2025/mceclip20_33.png',
  '/image/August2025/mceclip15_12.jpg',
  '/image/August2025/mceclip16_23.jpg',
  '/image/August2025/mceclip21_73.png',
  '/image/August2025/mceclip17_30.jpg',
]

// pattern: 2 ảnh ngang -> 1 ảnh dọc
function chunkImages(images: string[]) {
  const out: string[][] = []
  for (let i = 0; i < images.length; i += 3) {
    out.push(images.slice(i, i + 3))
  }
  return out
}

export default function CareShareMasonry() {
  const groups = chunkImages(galleryImages)

  return (
    <HomeContainer className='mt-10 bg-neutral-800 py-20'>
      <div className='mb-5 flex items-center gap-2 text-white md:mb-10'>
        <Image
          src={ImageHelper.getImageUrl('/image/August2025/mceclip3_68.png')}
          alt='Care and share icon'
          width={50}
          height={50}
          unoptimized
          className='h-9 w-auto md:h-15'
        />
        <div className='text-3xl font-semibold uppercase md:text-5xl'>
          by Coolmate
        </div>
      </div>

      <Marquee speed='slow' repeat={4} mask={false}>
        {groups.map((group, groupIndex) => (
          <MarqueeItem key={groupIndex} className='mx-2'>
            <div className='flex gap-4'>
              {/* Column with 2 horizontal images */}
              <div className='flex flex-col gap-4'>
                {group.slice(0, 2).map((img, i) => (
                  <div
                    key={i}
                    className='relative overflow-hidden rounded-lg max-md:aspect-[4/3] max-md:w-[250px] md:h-[300px] md:w-[587px]'
                  >
                    <Image
                      src={ImageHelper.getImageUrl(img)}
                      alt={`Gallery image ${groupIndex * 3 + i + 1}`}
                      fill
                      className='object-cover'
                      loading='lazy'
                    />
                  </div>
                ))}
              </div>

              {/* Column with 1 vertical image */}
              {group[2] && (
                <div className='flex flex-col gap-4'>
                  <div className='relative h-full overflow-hidden rounded-lg max-md:aspect-[3/4] max-md:h-full max-md:w-[250px] md:w-[587px]'>
                    <Image
                      src={ImageHelper.getImageUrl(group[2])}
                      alt={`Gallery image ${groupIndex * 3 + 3}`}
                      fill
                      className='h-full object-cover'
                      loading='lazy'
                    />
                  </div>
                </div>
              )}
            </div>
          </MarqueeItem>
        ))}
      </Marquee>
    </HomeContainer>
  )
}
